import React from "react";

export default function Target() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.78125 0.46875C3.03516 0.46875 0 3.53125 0 7.25C0 10.9961 3.03516 14.0312 6.78125 14.0312C10.5 14.0312 13.5625 10.9961 13.5625 7.25C13.5625 3.53125 10.5 0.46875 6.78125 0.46875ZM6.78125 12.2812C3.99219 12.2812 1.75 10.0391 1.75 7.25C1.75 4.48828 3.99219 2.21875 6.78125 2.21875C9.54297 2.21875 11.8125 4.48828 11.8125 7.25C11.8125 10.0391 9.54297 12.2812 6.78125 12.2812ZM6.78125 3.75C4.83984 3.75 3.28125 5.33594 3.28125 7.25C3.28125 9.19141 4.83984 10.75 6.78125 10.75C8.69531 10.75 10.2812 9.19141 10.2812 7.25C10.2812 5.33594 8.69531 3.75 6.78125 3.75ZM6.78125 9C5.79688 9 5.03125 8.23438 5.03125 7.25C5.03125 6.29297 5.79688 5.5 6.78125 5.5C7.73828 5.5 8.53125 6.29297 8.53125 7.25C8.53125 8.23438 7.73828 9 6.78125 9Z"
        fill="currentColor"
      />
    </svg>
  );
}
